<template>
  <div class="documentation">
    <div class="row">
      <div class="col-md-5">
        <Breadcumb title="Inviter un utilisateur" :breadcumb-data="breadcumbData"></Breadcumb>
      </div>
    </div>
    <b-card class="cardcontainer">
      <b-form @submit="addUser">
  
        <span style="color:#ff0000" v-if="error">{{ error }}</span>
        <b-form-group label="Nom" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          
          <b-input type="text" placeholder="Nom" v-model="lastname"/>
          <b-alert  v-if="errors['lastname']" show variant="danger">
            {{ errors['lastname'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Prénom" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Prénom" v-model="firstname"/>
          <b-alert  v-if="errors['firstname']" show variant="danger">
            {{ errors['firstname'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Email" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Email" v-model="email"/>
          <b-alert  v-if="errors['email']" show variant="danger">
            {{ errors['email'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Type d'utilisateur" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-select plain v-model="user_type_id" :options="userTypeData"/>
          <b-alert  v-if="errors['user_type_id']" show variant="danger">
            {{ errors['user_type_id'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Accès au coaching" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <input style="height:20px; width:20px" type="checkbox" value="true" v-model="coaching"/>
        </b-form-group>
        <b-form-group label="Accès au soutient à la demande" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <input style="height:20px; width:20px" type="checkbox" value="true" v-model="support"/>
        </b-form-group>
        <b-form-group label="Accès au Co-dev" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <input style="height:20px; width:20px" type="checkbox" value="true" v-model="codev"/>
        </b-form-group>
        <b-form-row>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Inviter l'utilisateur</b-btn>
          </div>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
  import { ADMIN_GET_USERTYPES_REQUEST} from '../../_store/administration/user/actiontypes'
  import {INVITE_USER_REQUEST, USER_REQUEST} from '../../_store/user/actiontypes';
  import Breadcumb from '../../components/breadcumb';
  import { mapState } from 'vuex';
  
  export default {
    name: 'adminCategoryAdd',
    components: {Breadcumb },
    mounted() {
      this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
              .then(response => {
                this.userTypeData = response.data.usertypes.map(userType => {
                      return {
                        value: userType.id,
                        text: userType.label
                      };
                    })
                });
    },
    computed: mapState({ errors: state => state.admin_user.errors }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des utilisateurs', href: '/dashboard/administration/userlist/'},
          { text: 'Inviter un utilisateur', active: true},

        ],
        companyData: [],
        companies: {},
        userTypeData: [],
        user_type_id: 0,
        company_id: 0,
        email: '',
        error: false,
        lastname: '',
        firstname: '',
        coaching: true,
        codev: true,
        support: true
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      addUser: function (e) {
        e.preventDefault();
        this.$store.dispatch(INVITE_USER_REQUEST, {
          lastname: this.lastname,
          firstname: this.firstname,
          email: this.email,
          user_type_id: this.user_type_id,
          codev: this.codev,
          coaching: this.coaching,
          support: this.support
        })
          .then(() => {
            this.$router.push('/dashboard/administration/userlist/');
          })
          .catch((error) => {
            if (error.error.user === 'noperimeter') {
              this.error = this.$t('noperimeter')
            } else if (error.error.email === 'duplicate'){
              this.error = this.$t('duplicate_email')
            }
          });
      }
    }
  };
</script>
